// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3rL66","content":"styles_content__1SO4s"};